module.exports = [{"id":1,"val":"zh-Hans","lang":"中文"},{"id":2,"val":"zh-Hant","lang":"繁体"},{"id":3,"val":"ja-JP","lang":"日文"},{"id":4,"val":"ko-KR","lang":"韩文"},{"id":5,"val":"ru-RU","lang":"俄文"},{"id":6,"val":"en-US","lang":"英文"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/lang_config.json
// module id = L0pq
// module chunks = 1